import { lazy } from "react";

import { ErrorPage } from '../components/ErrorPage';
import PaymentHandler from '../common/Provider/payment';
import OAuthHandler from '../common/Provider/oauth';

const Snap = lazy(() => import('../mobilecomponents/Snap'));
const Login = lazy(() => import('../mobilecomponents/login'));

import NewRodin from "../components/newRodin";
const HomePage = lazy(() => import('../mobilecomponents/homepage'));

const MobileRouter = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: "/chatavatar/:taskUUid?",
    element: <HomePage />,
  },
  {
    path: "/imageto3d/:taskUUid?",
    element: <HomePage />,
  },
  {
    path: "/rodin",
    element: <NewRodin />,
  },
  {
    path: "/rodin/:taskUUid?",
    element: <NewRodin />,
  },
  {
    path: "/snap",
    element: <Snap />,
  },
  {
    path: "/error",
    element: <ErrorPage />,
  },
  {
    path: "/payment",
    element: <PaymentHandler />,
  },
  {
    path: "/customlogin",
    element: <Login />,
  },
  {
    path: "/login",
    element: <OAuthHandler />,
  },
  {
    path: "/rodin/*",
    element: <ErrorPage errorCode={404} isFullPage={true} />,
  },
]

export default MobileRouter;

